import React from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PageHeroBanner } from '../../components/PageHeroBanner';
import { ServiceCTABanner } from '../../components/ServiceCTABanner';
import { CTAButton, CTABar, CTAButtonOnBlue, MidPageCTAStrip } from '../../components/ServiceInlineCTA';
import { CheckCircleIcon, ArrowRightIcon, UsersIcon, WrenchIcon, LeafIcon, CalendarIcon, DollarSignIcon, SearchIcon, ThumbsUpIcon, BuildingIcon, ShieldCheckIcon, HeartIcon, TrendingUpIcon, SmileIcon } from 'lucide-react';
const OTHER_SERVICES = [{
  name: 'Backyard Cleaning',
  slug: 'backyard-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp'
}, {
  name: 'Driveway Cleaning',
  slug: 'driveway-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp'
}, {
  name: 'Paver Cleaning',
  slug: 'paver-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp'
}, {
  name: 'Solar Panel Cleaning',
  slug: 'solar-panel-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp'
}, {
  name: 'Trash Can Cleaning',
  slug: 'trash-can-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp'
}, {
  name: 'Window Cleaning',
  slug: 'window-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp'
}];
const headingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 900 as const,
  lineHeight: 1.2
};
const bodyStyle = {
  color: '#025A8A',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: 1.8
};
const subHeadingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 800 as const,
  lineHeight: 1.3
};
export function CommercialCleaningPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-1178">
      <Navbar data-id="element-1179" />
      <main data-id="element-1180">
        {/* Hero */}
        <PageHeroBanner eyebrow="Service" headline="Commercial Cleaning" subheadline="To keep your workspaces shining and pristine, we provide professional commercial cleaning services tailored to meet your needs. Our dedicated team ensures that every corner of your facility is thoroughly cleaned and well-maintained, creating a spotless environment for both employees and clients." ctaPrimary={{
        label: 'Get A Free Quote',
        href: '#quote'
      }} ctaSecondary={{
        label: 'Contact Us',
        href: '#contact'
      }} data-id="element-1181" />

        {/* Section — Service Overview (Split Layout) */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1182">
          <div className="max-w-7xl mx-auto" data-id="element-1183">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16" data-id="element-1184">
              <div className="w-full lg:w-1/2" data-id="element-1185">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-1186">
                  <img src="https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp" alt="Commercial Cleaning Service" className="w-full h-auto object-cover" style={{
                  maxHeight: '500px'
                }} data-id="element-1187" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-1188">
                <h2 className="font-bold mb-6" style={{
                ...headingStyle,
                fontSize: 'clamp(24px, 4vw, 30px)'
              }} data-id="element-1189">
                  Commercial Cleaning Services: Professional, Reliable Solutions
                  for a Spotless Business Environment
                </h2>
                <p className="mb-4" style={bodyStyle} data-id="element-1190">
                  A clean and well-maintained commercial property is crucial for
                  creating a positive impression on clients, customers, and
                  employees. Our professional commercial cleaning service
                  provides comprehensive solutions to ensure your business's
                  exterior looks immaculate, promoting a welcoming environment
                  and enhancing your property's curb appeal.
                </p>
                <p style={bodyStyle} data-id="element-1191">
                  From power washing sidewalks and facades to meticulous window
                  cleaning and debris removal, we have the experience,
                  equipment, and dedication to keep your commercial space
                  pristine.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1192" />

        {/* Section — Why Commercial Cleaning is Important */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1193">
          <div className="max-w-7xl mx-auto" data-id="element-1194">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1195">
              Why Commercial Cleaning is Important
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1196">
              Cleanliness is an essential aspect of a business's image, but it
              also has practical benefits for your property's longevity, safety,
              and value. Here's why regular commercial cleaning is a wise
              investment:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1197">
              <div className="flex gap-5" data-id="element-1198">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1199">
                  <SmileIcon className="h-6 w-6 text-white" data-id="element-1200" />
                </div>
                <div data-id="element-1201">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1202">
                    First Impressions Matter
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1203">
                    A clean exterior creates an inviting environment, making a
                    positive first impression on clients, potential customers,
                    and employees. Maintaining a clean space reflects your
                    attention to detail and commitment to professionalism.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1204">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1205">
                  <ShieldCheckIcon className="h-6 w-6 text-white" data-id="element-1206" />
                </div>
                <div data-id="element-1207">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1208">
                    Enhances Safety and Compliance
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1209">
                    Dirt, moss, algae, and other contaminants can make pathways,
                    driveways, and entryways slippery, posing a safety hazard
                    for employees and visitors. Regular cleaning ensures that
                    surfaces are free of buildup, promoting a safer environment.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1210">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1211">
                  <WrenchIcon className="h-6 w-6 text-white" data-id="element-1212" />
                </div>
                <div data-id="element-1213">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1214">
                    Prolongs the Life of Your Property
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1215">
                    Dirt, grime, and pollution can cause wear and tear on
                    surfaces over time. Routine cleaning prevents deterioration,
                    which extends the life of your property's exterior surfaces
                    and saves you money on repairs or replacements.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1216">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1217">
                  <TrendingUpIcon className="h-6 w-6 text-white" data-id="element-1218" />
                </div>
                <div data-id="element-1219">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1220">
                    Boosts Property Value
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1221">
                    A well-maintained property increases its market value and
                    makes it more appealing for tenants, investors, and
                    visitors. Clean exteriors enhance the overall look and
                    appeal of the property, increasing its desirability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABar data-id="element-1222" />

        {/* Section — Comprehensive Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1223">
          <div className="max-w-7xl mx-auto" data-id="element-1224">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1225">
              Our Comprehensive Commercial Cleaning Services
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1226">
              Our commercial cleaning service covers every aspect of exterior
              cleaning to ensure your property looks its best. We use top-grade
              equipment, eco-friendly cleaning solutions, and time-tested
              techniques to deliver superior results.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1227">
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1228">
                <div className="flex items-center gap-4 mb-4" data-id="element-1229">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1230">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1231">
                      1
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1232">
                    Power Washing for Entrances, Walkways &amp; Sidewalks
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1233">
                  High-traffic areas are prone to grime buildup. We use
                  high-pressure power washing to remove dirt, grease, gum, and
                  tough stains, restoring your concrete, stone, or brick
                  surfaces to a like-new condition.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1234">
                <div className="flex items-center gap-4 mb-4" data-id="element-1235">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1236">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1237">
                      2
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1238">
                    Facade Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1239">
                  Building facades accumulate dirt, dust, pollution, and
                  biological growth. We clean facades of all types — brick,
                  stone, stucco, metal, and glass — using soft washing and power
                  washing techniques that preserve the integrity of your
                  building's exterior.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1240">
                <div className="flex items-center gap-4 mb-4" data-id="element-1241">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1242">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1243">
                      3
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1244">
                    Window Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1245">
                  Clean windows improve appearance while enhancing indoor
                  lighting. We use purified water systems and squeegees for
                  streak-free, spotless windows — both interior and exterior —
                  removing dust, smudges, and pollutants.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1246">
                <div className="flex items-center gap-4 mb-4" data-id="element-1247">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1248">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1249">
                      4
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1250">
                    Gutter Cleaning &amp; Maintenance
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1251">
                  Clogged gutters lead to water damage, leaks, and mold growth.
                  Our team removes debris and blockages, ensuring proper water
                  flow and preventing potential damage. We also inspect gutters
                  for signs of wear.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1252">
                <div className="flex items-center gap-4 mb-4" data-id="element-1253">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1254">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1255">
                      5
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1256">
                    Roof Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1257">
                  Roof surfaces accumulate moss, algae, and lichen. Our
                  low-pressure washing techniques safely remove these
                  contaminants, preserving your roof's integrity while enhancing
                  its appearance. We're trained to work safely on all roof
                  types.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1258">
                <div className="flex items-center gap-4 mb-4" data-id="element-1259">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1260">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1261">
                      6
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1262">
                    Parking Lot &amp; Garage Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1263">
                  Parking areas quickly accumulate dirt, oil stains, gum, and
                  litter. We provide thorough power washing to make your parking
                  areas look well-maintained and professional, reducing slip
                  hazards from oil spills and grime.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1264">
                <div className="flex items-center gap-4 mb-4" data-id="element-1265">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1266">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1267">
                      7
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1268">
                    Graffiti Removal
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1269">
                  Graffiti can impact your professional image. We quickly and
                  effectively eliminate unsightly markings from walls, fences,
                  signs, and other surfaces using specialized techniques that
                  won't damage the underlying material.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1270">
                <div className="flex items-center gap-4 mb-4" data-id="element-1271">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1272">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1273">
                      8
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1274">
                    Awning &amp; Sign Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1275">
                  Awnings and signage become faded and dirty over time. We
                  provide gentle cleaning that restores their color and clarity,
                  keeping your brand's image sharp and visible — especially
                  important for attracting customers.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1276">
                <div className="flex items-center gap-4 mb-4" data-id="element-1277">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1278">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1279">
                      9
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1280">
                    Trash Can &amp; Dumpster Area Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1281">
                  Dumpster and trash can areas are prone to unpleasant odors,
                  spills, and grime. We offer cleaning and deodorizing services
                  to maintain these areas, preventing bad smells and creating a
                  more sanitary environment.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButtonOnBlue data-id="element-1282" />

        {/* Section — Why Choose Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1283">
          <div className="max-w-7xl mx-auto" data-id="element-1284">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1285">
              Why Choose Our Commercial Cleaning Service?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1286">
              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1287">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1288">
                  <UsersIcon className="h-6 w-6 text-white" data-id="element-1289" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1290">
                  Experienced Professionals
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1291">
                  Our team has years of experience in commercial cleaning, using
                  the latest techniques and equipment to achieve exceptional
                  results tailored to your specific needs.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1292">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1293">
                  <WrenchIcon className="h-6 w-6 text-white" data-id="element-1294" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1295">
                  High-Quality Equipment
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1296">
                  We invest in industrial-grade cleaning equipment that is
                  efficient and effective, ensuring your property receives the
                  best care possible.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1297">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1298">
                  <LeafIcon className="h-6 w-6 text-white" data-id="element-1299" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1300">
                  Eco-Friendly Solutions
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1301">
                  Our cleaning solutions are biodegradable and environmentally
                  friendly — safe for both surfaces and the surrounding
                  environment.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1302">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1303">
                  <CalendarIcon className="h-6 w-6 text-white" data-id="element-1304" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1305">
                  Flexible Scheduling
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1306">
                  We offer early morning, evening, and weekend availability to
                  minimize disruption to your business operations.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1307">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1308">
                  <DollarSignIcon className="h-6 w-6 text-white" data-id="element-1309" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1310">
                  Cost-Effective Maintenance Plans
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1311">
                  Routine maintenance plans keep your property looking its best
                  year-round, helping you avoid more costly deep cleanings.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1312">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1313">
                  <SearchIcon className="h-6 w-6 text-white" data-id="element-1314" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1315">
                  Attention to Detail
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1316">
                  We take the time to address every detail, ensuring your
                  property is spotless and well-maintained. Your satisfaction is
                  guaranteed.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Mid-Page CTA Strip */}
        <MidPageCTAStrip data-id="element-1317" />

        {/* Section — Benefits */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1318">
          <div className="max-w-7xl mx-auto" data-id="element-1319">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1320">
              Benefits of Regular Commercial Cleaning
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1321">
              <div className="flex gap-5" data-id="element-1322">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1323">
                  <BuildingIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1324" />
                </div>
                <div data-id="element-1325">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1326">
                    Enhances Professional Image
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1327">
                    A clean, well-maintained property promotes a professional
                    and trustworthy image, helping to attract and retain
                    customers and clients.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1328">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1329">
                  <SmileIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1330" />
                </div>
                <div data-id="element-1331">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1332">
                    Increases Employee Morale
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1333">
                    A clean, welcoming work environment has a positive impact on
                    employees, boosting morale and encouraging productivity.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1334">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1335">
                  <ShieldCheckIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1336" />
                </div>
                <div data-id="element-1337">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1338">
                    Reduces Liability
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1339">
                    Removing dirt, debris, and stains from walking paths and
                    parking areas reduces slip hazards and promotes a safer
                    environment for visitors and employees.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1340">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1341">
                  <TrendingUpIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1342" />
                </div>
                <div data-id="element-1343">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1344">
                    Protects Your Investment
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1345">
                    Regular cleaning prevents the buildup of damaging elements,
                    preserving the quality of your exterior surfaces and
                    protecting your investment.
                  </p>
                </div>
              </div>

              <div className="flex gap-5 md:col-span-2 md:max-w-lg md:mx-auto" data-id="element-1346">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1347">
                  <HeartIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1348" />
                </div>
                <div data-id="element-1349">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1350">
                    Improves Health and Hygiene
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1351">
                    Maintaining a clean environment reduces allergens, mold, and
                    pollutants, promoting better health and hygiene for everyone
                    on the property.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Property Types */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1352">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1353">
            <h2 className="font-bold mb-10" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1354">
              Commercial Cleaning for All Types of Properties
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1355">
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1356">
                Office Buildings
              </div>
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1357">
                Retail Stores &amp; Shopping Centers
              </div>
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1358">
                Restaurants &amp; Cafes
              </div>
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1359">
                Medical &amp; Healthcare
              </div>
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1360">
                Schools &amp; Universities
              </div>
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1361">
                Warehouses &amp; Industrial
              </div>
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1362">
                Hotels &amp; Hospitality
              </div>
              <div className="bg-white rounded-xl p-5 font-semibold text-sm" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1363">
                Apartments &amp; Condos
              </div>
            </div>
          </div>
        </section>

        {/* Section — Other Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1364">
          <div className="max-w-7xl mx-auto" data-id="element-1365">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 30px)'
          }} data-id="element-1366">
              Explore Our Other Services
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-1367">
              {OTHER_SERVICES.map(service => <a key={service.slug} href={`/services/${service.slug}`} className="bg-white rounded-xl p-5 text-center transition-all hover:shadow-lg hover:scale-[1.02] flex flex-col items-center gap-3 border" style={{
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)',
              borderColor: '#E8F4FD'
            }} data-id="element-1368">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1369">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover" data-id="element-1370" />
                  </div>
                  <p className="font-bold text-sm" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '13px'
              }} data-id="element-1371">
                    {service.name}
                  </p>
                  <span className="flex items-center gap-1 text-xs font-semibold" style={{
                color: '#0283C7',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1372">
                    Learn More <ArrowRightIcon className="h-3 w-3" data-id="element-1373" />
                  </span>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <ServiceCTABanner headline="Ready to Transform Your Commercial Property?" data-id="element-1374" />
      </main>
      <Footer data-id="element-1375" />
    </div>;
}